
import parent from '../../wgg/wgg.module';
import html from  './map.html';
import ctrl from './map.controller';
import scss from './map.scss';

parent.component('map', {
    template: html,
    controller: ctrl
});



// WEBPACK FOOTER //
// ./src/components/map/map.component.js